import { Stack } from '@mui/material'

import { DmRoomsQuery, Maybe } from '@/clients/utoniq-core/schema'
import { Head } from '@/components/layouts'
import { BaseLayout } from '@/components/layouts/BaseLayout'
import { DmRoomBox } from '@/components/organisms/dmRoom/DmRoomBox'
import { DmRoomSkeleton } from '@/components/organisms/dmRoom/DmRoomSkeleton'
import { ScrollFetcher } from '@/components/organisms/functionals'
import { styles } from '@/components/styles'
import { useRouter, useTranslation } from '@/core'
import { Template } from '@/core/architecture'

export * from './fragments'

export type State = {
  userId: string
  dmRooms: Maybe<DmRoomsQuery['userDmRooms']>
  loading: boolean
  hasNextPage: boolean
}

export type Action = {
  onFetchMore: () => Promise<void>
}

export const DmRoomsTemplate: Template<State, Action> = ({
  state,
  onFetchMore,
}) => {
  const { t } = useTranslation('dmRooms')
  const { routerNames } = useRouter()

  return (
    <>
      <Head title={routerNames.DmRooms} />

      <BaseLayout
        header={{
          title: t('title'),
          back: true,
        }}
        sx={{
          pb: styles.safeAreaBottom,
        }}
      >
        <Stack sx={{ px: 4 }}>
          <ScrollFetcher
            componentProps={{ sx: { pt: 2, pb: 5 }, spacing: 5 }}
            nodes={state.dmRooms?.edges.map(({ node }) => (
              <DmRoomBox key={node.id} dmRoom={node} />
            ))}
            onFetchMore={onFetchMore}
            loading={state.loading}
            hasNextPage={state.hasNextPage}
            emptyMessage={t('emptyDmRoom')}
            loadingComponent={
              <Stack spacing={5} sx={{ pb: 7 }}>
                {Array.from(Array(4).keys()).map(key => (
                  <DmRoomSkeleton key={key} />
                ))}
              </Stack>
            }
          />
        </Stack>
      </BaseLayout>
    </>
  )
}
